import React, { useEffect, useState, FC } from 'react'
import UIkit from 'uikit'
import UserInfo from './dropdown/UserInfo'
import { connect } from 'react-redux'
import { storage } from '../../firebase'
import { Link } from 'react-router-dom'
import { RootState } from '../../store/reducers'
import { User } from '../../models/user'
import Notifications from './dropdown/Notifications'

const Appbar: FC<{ user: User; isAuthenticated: boolean }> = ({
  user,
  isAuthenticated,
}) => {
  const [primg, setPrimg] = useState('')
  const [search, setSearch] = useState(false)
  const [query, setQuery] = useState('')
  const { pimage } = user

  useEffect(() => {
    let mounted = true

    const links = document.querySelectorAll(`.dcl`)
    links.forEach((link) => {
      link.addEventListener('click', () => {
        const el = document.querySelector(`#acc-dropdown`)
        if (el) UIkit.dropdown(el).hide()
      })
    })

    if (isAuthenticated) {
      if (user.img !== '') {
        storage
          .ref(`profiles/${user?.id}`)
          .getDownloadURL()
          .then((url) => {
            if (mounted) {
              setPrimg(url)
            }
          })
      }
    }

    return () => {
      mounted = false
    }
  })

  return (
    <div className="appbar app-text">
      <div className="ss" style={{ fontSize: '18px', fontWeight: 'bold' }}>
        Lodies
      </div>
      <div className="search ls">
        <input type="search" placeholder="search" name="search" id="search" />
      </div>
      {search && (
        <div className="search ss">
          <form
            onSubmit={(e) => {
              e.preventDefault()
              setSearch(false)
              console.log(query)
            }}
          >
            <input
              autoFocus
              type="search"
              placeholder="search"
              style={{ width: '160px' }}
              name="search"
              id="search"
              onChange={(e) => setQuery(e.target.value)}
            />
          </form>
        </div>
      )}
      <div className="appbar-actions">
        <span className="ss">
          <Link
            // onBlur={() => setSearch(!search)}
            onClick={() => setSearch(!search)}
            to="/search"
            style={{ color: `var(--text-color)` }}
          >
            <i className="material-icons-outlined md-24">search</i>
          </Link>
        </span>{' '}
        <span>
          <span>
            <i className="material-icons-outlined md-24">notifications</i>
          </span>{' '}
          <Notifications />
        </span>
        <div>
          <div className="nav-user">
            <span className="ls">{user && <span>{user.username}</span>}</span>
            <div
              className="user-circle"
              style={{
                backgroundSize: 'cover !important',
                background: primg
                  ? `url(${primg})`
                  : pimage
                  ? `url(${pimage})`
                  : `#ddd`,
              }}
            ></div>
          </div>
          <UserInfo />
        </div>
      </div>
    </div>
  )
}

const mapState = (state: RootState) => ({
  user: state.auth.user,
  isAuthenticated: state.auth.isAuthenticated,
})

export default connect(mapState)(Appbar)
